import type { IUserGtmInfoPayload } from '@/interfaces'
import { pushBtnBannerHarvestGtmEvent } from '@/logic/metrika/harvest/gtmEvents'
import type { IRegion } from '@/types'

export const pushGtmEvent = (userGtmInfo: IUserGtmInfoPayload, userRegion: IRegion) =>
  pushBtnBannerHarvestGtmEvent(
    {
      items: [],
      pagePart: 'content',
      blockName: 'blockHarvestSale',
      eventCategory: 'interactions',
      eventAction: 'click',
      eventLabel: 'buttonHarvestSale',
      eventStatus: 'success',
      eventEcommerce: 'addToCart',
      ecommerceType: 'add',
      eventNonInteraction: '0',
      actionField: {
        list: 'previewLotsOutputs',
      },
      trueEventContext: null,
    },
    userRegion.name,
    userGtmInfo,
  )
